$(function() {
  function unlockSizeguideScroll() {
    if (window.scScheduleScrollRestore) window.scScheduleScrollRestore();
    else if (window.scRestorePageScroll) window.scRestorePageScroll();
    else document.body.style.removeProperty('overflow');
  }

  $('.sizeguide_toggler, .sizeguide_wrapper--close').click(() => {
      if ($('.sizeguide_wrapper').is(':visible')) {
        $('.sizeguide_wrapper').hide();
        unlockSizeguideScroll();
    } else {
        $('.sizeguide_wrapper').show();

        if ( window.innerWidth <= 768 ) {
            $('body').css('overflow', 'hidden');
        }
      }
  });

  // Scrolling the window will close the popup
  $(window).scroll(() => {
      if ( window.innerWidth > 768 && $('.sizeguide_wrapper').is(':visible') ) {
          $('.sizeguide_wrapper').hide();
          unlockSizeguideScroll();
      }
  });

  // Clicks outside the wrapper will close the popup
  $(document).mouseup(e => {
      if (!$('.sizeguide_wrapper').is(':visible')) return;
      if (!$('.sizeguide_wrapper').is(e.target) && $('.sizeguide_wrapper').has(e.target).length === 0) {
          $('.sizeguide_wrapper').hide();
          unlockSizeguideScroll();
      }
  });

}); // DOM Loaded
